// Action Types
const SET_TOKENS = "SET_TOKENS";
const CLEAR_TOKENS = "CLEAR_TOKENS";

// Action Creators
export const setTokens = ({ accessToken, refreshToken }) => ({
  type: SET_TOKENS,
  payload: {
    ...(accessToken !== undefined && { accessToken }),
    ...(refreshToken !== undefined && { refreshToken }),
  },
});

export const clearTokens = (type = "All") => ({
  type: CLEAR_TOKENS,
  payload: {
    ...(type === "All" && initialState),
    ...(type === "accessToken" && { accessToken: null }),
    ...(type === "refreshToken" && { refreshToken: null }),
  },
});

// Initial State
const initialState = {
  accessToken: null,
  refreshToken: null,
};

// Reducer
export default function tokenReducer(state = initialState, action) {
  switch (action.type) {
    case SET_TOKENS:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_TOKENS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
